export class  Exercise {
    public uid: string;
    public $id: string;
    public id: string;
    public img: string;
    public link?: string;
    public notes?: string;
    public photo: boolean;
    public title: string;
    public status: "active" | "archived";
    public organization?: string;
    public exerciseTypes?: string[];
    public bodyParts?: string[];
    public equipment?: string[];
    public creationDate?: string;
    public featured?: boolean;
    public reviewed?: boolean;
    public alternatives?: string[];
    public video?: string;

    constructor (init: Partial<Exercise>){
        Object.assign(this, init);
    }
}